import { getCartIDAndAuth } from '@src/quince-site-common/src/hooks/cart/hooks/new-cart-helper'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

export function getExpressCheckoutSrc(
  isI18nPreviewEnabled: boolean,
  showBothButtons: boolean,
  isMobile?: boolean,
  locale?: string,
) {
  const { cartID, authCode } = getCartIDAndAuth()

  if (!cartID || !authCode || !isBrowser()) {
    return {
      src: '',
    }
  }

  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    const origin = `http://localhost:4200`

    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    let checkoutUrl = `checkout/express-checkout-buttons?cart_id=${cartID}&cart_auth_Code=${authCode}&show_both=${showBothButtons}&show_large_buttons=${isMobile}`
    if (isI18nPreviewEnabled) {
      checkoutUrl = `${locale}/${checkoutUrl}`
    }
    return {
      src: `${origin}/${checkoutUrl}`,
    }
  }

  const origin = window.location.origin

  const url = new URL(origin)
  // @i18n-ignore
  let checkoutUrl = `checkout/express-checkout-buttons`
  if (isI18nPreviewEnabled) {
    checkoutUrl = `${locale}/${checkoutUrl}`
  }
  url.pathname = checkoutUrl
  url.searchParams.append('cart_id', cartID)
  // eslint-disable-next-line i18next/no-literal-string
  url.searchParams.append('cart_auth_Code', authCode)
  url.searchParams.append('show_both', `${showBothButtons}`)
  url.searchParams.append('show_large_buttons', `${isMobile}`)
  return { src: url.href }
}
